import React from 'react'
import Layout from '../Components/Layout'
import HeroGlobal from '../Components/HeroGlobal'
import Contact from '../Components/Contact'
import useDocumentTitle from '../Hooks/PageTitle'

const ContactPage = () => {
  useDocumentTitle("TRoo Dental | Contact Page")
  return (
    <Layout>
        <HeroGlobal title="Contact And Inquiry Form" />
        <Contact/>
    </Layout>
  )
}

export default ContactPage